import {memo} from 'react';
import {Routes,Route} from 'react-router-dom';
import {default as ConfirmRequestPayment} from './ConfirmRequeryPayment';
import {default as UploadPayment} from './UploadPayment';
import {default as ProcessOffLinePayment} from './ProcessOffLinePayment';
import TreatManualSubscription from './TreatManualSubscription';
import TransanctionHistory from './TransactionHistory';


const Transactions = () => {
  return (
    <Routes>
      <Route path="/" element={<TransanctionHistory />}/>
      <Route path="/transaction-history" element={<TransanctionHistory />}/>
      {/* <Route path="/confirm-payment" element={<ConfirmRequestPayment />} /> */}
      <Route path="/upload-payment" element={<UploadPayment />} />
      <Route path="/process-off-line-payment" element={<ProcessOffLinePayment />} />
      <Route path="/confirm-requery-payment" element={<ConfirmRequestPayment />} />
      <Route path="/treat-manual-subscription" element={<TreatManualSubscription />} />

    </Routes>
  )
}

export default memo(Transactions);


const DefaultTransaction = () =>{
  return <div>
    DefaultTransaction 
  </div>
}